import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { ADELPHI_FEINTS_DEFAULT_STATE } from './constants';

const completedState = completeState(ADELPHI_FEINTS_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [
    actions.CREATE_ADELPHI_FEINT,
    actions.GET_ALL_ADELPHI_FEINTS,
    actions.UPDATE_ADELPHI_FEINT_BY_ID,
    actions.GET_ADELPHI_FEINT_BY_ID
  ],
  override: { [actions.SET_CURRENT_ADELPHI_FEINT]: onReadValue() }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
